module.exports = __webpack_public_path__ + "static/img/1-3.587e54a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/1-3.png
// module id = 1308
// module chunks = 0